<template>
	<div
		class="select-location-mobile"
        style="margin-top: 15px; width: 100%; display: flex; justify-content: space-evenly;"
        v-if="locations.available.length && locations.available.length > 1"
	>
        <a
            href="#"
            @click.prevent="
                setLocation(location);
                selectedSlot = false;
            "
            class="nk-button nk-double-button"
            style="width: 100%;"
            v-for="location in locations.available"
            :key="'select-location-' + location"
            :class="{
                'nk-button': locations.selected != location || 
                        !locations.selected,
                'nk-button-new-beige': locations.selected == location
            }"
        >
            <a
                href="#"
                >{{ formatLocationNameInList(location) }}</a
            >
        </a>
	</div>
</template>


<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
	components: {},
	computed: {
		...mapState(["locations", "ui", "activities"]),
		...mapGetters(["formatLocationNameInList"])
	},
	methods: {
		...mapActions(["setLocation"])
	}
};
</script>